import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import ServiceModal from '../components/ServiceModal';
import './StructureAcoustic.css';

// Service data - same as ServiceDetail
const serviceData: { [key: string]: any } = {
  'akustik-duvar-yapimi': {
    title: 'Akustik Duvar Yapımı',
    description: 'Profesyonel akustik duvar kaplama çözümleri ile konferans salonlarınızda mükemmel ses kalitesi',
    type: 'Yalıtım Tipi',
    image: '/yapiakustikcozumler/akustikduvar.jpg.avif',
    images: [
      '/yapiakustikcozumler/akustikduvar.jpg.avif'
    ],
    features: [
      'Yüksek ses emilim katsayısı',
      'Ateşe dayanıklı malzemeler',
      'Estetik ve modern görünüm',
      'Kolay montaj ve bakım',
      'Uzun ömürlü yapı'
    ],
    content: `
      <p>Konferans salonlarında akustik performans, duvarların doğru şekilde yalıtılması ile başlar. Akustik duvar yapımı, sesin yansımasını kontrol ederek konuşma netliğini artırır ve yankı süresini optimize eder. Profesyonel akustik duvar sistemleri, salonun her noktasında eşit ses dağılımı sağlar ve dinleyici konforunu maksimize eder.</p>
      
      <h3>Akustik Duvar Sistemlerinin Önemi</h3>
      <p>Konferans salonlarında duvarlar, sesin yansıması ve emilimi açısından kritik rol oynar. Yanlış yapılandırılmış duvarlar, sesin belirli noktalarda toplanmasına veya aşırı yankılanmasına neden olur. Bu durum hem konuşmacının sesinin anlaşılabilirliğini azaltır hem de dinleyicilerin konsantrasyonunu bozar.</p>
      
      <p>Akustik duvar sistemleri şu avantajları sağlar:</p>
      <ul>
        <li><strong>Ses Yansıması Kontrolü:</strong> Duvarlardan gelen yansımaları minimize ederek konuşma netliğini artırır.</li>
        <li><strong>RT60 Optimizasyonu:</strong> Yankı süresini (RT60) ideal seviyeye indirerek salonun akustik performansını iyileştirir.</li>
        <li><strong>Gürültü Azaltma:</strong> Dışarıdan gelen sesleri engelleyerek salon içi akustiği korur.</li>
        <li><strong>Estetik Tasarım:</strong> Modern ve şık görünüm ile mimari bütünlük sağlar.</li>
        <li><strong>Enerji Verimliliği:</strong> Isı yalıtımı özellikleri ile enerji tasarrufu sağlar.</li>
      </ul>
      
      <h3>Kullanılan Malzemeler</h3>
      <p>Akustik duvar sistemlerinde kullanılan malzemeler, projenin ihtiyaçlarına göre seçilir. En yaygın kullanılan malzemeler:</p>
      <ul>
        <li><strong>Akustik Paneller:</strong> Mineral yün, cam yünü veya polyester esaslı paneller</li>
        <li><strong>Mikroperfore Paneller:</strong> Ahşap veya alüminyum yüzeyli, delikli paneller</li>
        <li><strong>Akustik Kumaş Kaplamalar:</strong> Yüksek ses emilim özellikli kumaş kaplamalar</li>
        <li><strong>Difüzör Paneller:</strong> Sesin kontrollü dağılımını sağlayan özel paneller</li>
        <li><strong>Akustik Süngerler:</strong> Yüksek frekanslı seslerin emilimi için özel süngerler</li>
      </ul>
      
      <h3>Uygulama Süreci</h3>
      <p>Nish Global olarak, akustik duvar yapımında şu adımları izliyoruz:</p>
      <ul>
        <li><strong>Akustik Analiz:</strong> Salonun mevcut akustik özelliklerini ölçüyoruz</li>
        <li><strong>Proje Tasarımı:</strong> İhtiyaçlara uygun akustik çözümler tasarlıyoruz</li>
        <li><strong>Malzeme Seçimi:</strong> En uygun akustik malzemeleri belirliyoruz</li>
        <li><strong>Profesyonel Montaj:</strong> Deneyimli ekibimizle hassas montaj yapıyoruz</li>
        <li><strong>Test ve Optimizasyon:</strong> Kurulum sonrası akustik testler yapıyoruz</li>
      </ul>
      
      <h3>Nish Global'in Avantajları</h3>
      <p>Yılların deneyimi ve teknolojik altyapımızla, her projeye özel çözümler sunuyoruz. Akustik duvar sistemlerimiz:</p>
      <ul>
        <li>Uluslararası standartlara uygun</li>
        <li>Uzun ömürlü ve dayanıklı</li>
        <li>Bakım gerektirmeyen yapıda</li>
        <li>Çevre dostu malzemelerden üretilmiş</li>
        <li>Garantili ve sertifikalı</li>
      </ul>
    `
  },
  'akustik-tavan-yapimi': {
    title: 'Akustik Tavan Yapımı',
    description: 'Asma tavan sistemleri ve akustik paneller ile mükemmel tavan akustiği',
    type: 'Yalıtım Tipi',
    image: '/yapiakustikcozumler/akustiktavan.jpg.avif',
    images: [
      '/yapiakustikcozumler/akustiktavan.jpg.avif'
    ],
    features: [
      'Asma tavan sistemleri',
      'Akustik panel uygulamaları',
      'Difüzör entegrasyonu',
      'Aydınlatma uyumlu tasarım',
      'RT60 optimizasyonu'
    ],
    content: `
      <p>Konferans salonlarında akustik performans yalnızca duvarlarla sınırlı değildir. Tavan yüzeyleri, sesin yayılımını ve yankı süresini doğrudan etkileyen temel yapılardan biridir. Özellikle yüksek tavanlı salonlarda, kontrolsüz ses yansımaları hem konuşma anlaşılabilirliğini azaltır hem de dinleyici konforunu olumsuz etkiler. Bu nedenle, tavan akustiği profesyonel çözümlerle ele alınmalı ve salonun kullanım amacına uygun şekilde planlanmalıdır.</p>
      
      <h3>Asma Tavan Sistemleri Neden Önemlidir?</h3>
      <p>Asma tavan sistemleri, akustik kontrolü sağlamak ve görsel bütünlük oluşturmak için tercih edilen modern çözümlerdir. Bu sistemler sayesinde tavan yüksekliği düşürülerek sesin daha hızlı sönümlenmesi sağlanır. Aynı zamanda ses emici panellerle kaplanarak RT60 süresi istenen seviyeye indirilebilir.</p>
      
      <p>Asma tavan uygulamalarının avantajları şunlardır:</p>
      <ul>
        <li>Yüksek frekanslı seslerin dağılmasını engeller</li>
        <li>Hacimden kaynaklı yankıyı azaltır</li>
        <li>Aydınlatma ve havalandırma sistemlerini gizleyerek estetik katkı sağlar</li>
        <li>Sesin yukarıdan geri yansımasını önler, böylece konuşma netliği artar</li>
        <li>Isı yalıtımı sağlayarak enerji verimliliğini artırır</li>
      </ul>
      
      <h3>Akustik Tavan Panelleri</h3>
      <p>Akustik tavan panelleri, sesin absorbe edilmesini sağlayan malzemelerdir. Bu paneller çoğunlukla mineral yün, cam yünü veya yüksek yoğunluklu polyesterden üretilir. Panel yüzeyleri mikro delikli veya kumaş kaplı olabilir. Seçim yapılırken salonun kullanım amacı ve hedef RT60 değeri dikkate alınmalıdır.</p>
      
      <p>Konferans salonlarında en çok tercih edilen panel türleri:</p>
      <ul>
        <li><strong>Mikroperfore Paneller:</strong> Ahşap veya alüminyum yüzeyli, estetik ve dayanıklı</li>
        <li><strong>Akustik Taş Yünü Paneller:</strong> Yüksek ses emilim katsayısı, ateşe dayanıklı</li>
        <li><strong>Poliester Esaslı Sünger Paneller:</strong> Hafif ve esnek, kolay montaj</li>
        <li><strong>Baffle ve Canopy Sistemleri:</strong> Asılı yüzey panelleri, modern görünüm</li>
      </ul>
      
      <p>Bu panellerin yerleşimi simetrik ve dengeli olmalı, hem konuşmacı hem dinleyici yönünde ses emilimini optimize edecek şekilde planlanmalıdır.</p>
      
      <h3>Difüzörlerin Rolü</h3>
      <p>Difüzörler, sesin geliş yönüne göre yansımasını kontrollü şekilde dağıtan akustik elemanlardır. Özellikle sahne üstü veya salon tavanının arka yarısında kullanıldıklarında, homojen ses yayılımı sağlarlar. Difüzörler, yankıyı engellemekten çok, sesin belirli noktalarda toplanmasını önleyerek salonun her noktasında eşit ses algısı oluşturur.</p>
      
      <p>Difüzör türleri:</p>
      <ul>
        <li>Kare prizmatik difüzörler</li>
        <li>Yaylı yüzey difüzörler</li>
        <li>Üç boyutlu ahşap difüzörler</li>
        <li>QRD (Quadratic Residue Diffuser) sistemleri</li>
      </ul>
      
      <p>Doğru kullanıldığında difüzörler, sadece akustik değil aynı zamanda mimari estetik açısından da katkı sağlar.</p>
      
      <h3>Nish Global'in Tavan Akustiği Yaklaşımı</h3>
      <p>Nish Global olarak, her projede salonun tavan yapısı, kullanım amacı ve teknik ihtiyaçları analiz edilerek akustik planlama yapılır. Asma tavan sistemleri, akustik paneller ve difüzörler, yalnızca katalog ürünü değil; her projeye özel mühendislik çözümüdür.</p>
      
      <p>Proje sürecinde sunduğumuz hizmetler:</p>
      <ul>
        <li>Salon hacmine özel RT60 hedefleme</li>
        <li>Asma tavan sistemlerinde malzeme seçimi</li>
        <li>Akustik panel yerleşim planı</li>
        <li>Difüzör uygulaması gereklilik analizi</li>
        <li>Teknik çizim ve görselleştirme desteği</li>
        <li>Profesyonel montaj ve test hizmetleri</li>
      </ul>
    `
  },
  'zemin-yukseltme': {
    title: 'Zemin Yükseltme',
    description: 'Basamaklı zemin sistemleri ile görüş açısını optimize edin',
    type: 'Basamak Tipi',
    image: '/yapiakustikcozumler/zeminyukseltme.jpg.avif',
    images: [
      '/yapiakustikcozumler/zeminyukseltme.jpg.avif'
    ],
    features: [
      'Optimal görüş açısı',
      'Ses yayılımı optimizasyonu',
      'Erişilebilirlik standartları',
      'Dayanıklı yapı',
      'Estetik tasarım'
    ],
    content: `
      <p>Konferans salonlarında zemin yükseltme sistemleri, hem görsel hiyerarşi hem de akustik performans açısından kritik öneme sahiptir. Basamaklı zemin yapısı, salonun her noktasından sahnenin net görülmesini sağlar ve aynı zamanda ses yayılımını optimize eder.</p>
      
      <h3>Zemin Yükseltme Sistemlerinin Avantajları</h3>
      <ul>
        <li><strong>Görüş Açısı Optimizasyonu:</strong> Her koltuktan sahnenin net görülmesini sağlar</li>
        <li><strong>Ses Yayılımı İyileştirme:</strong> Basamaklı yapı sesin daha iyi dağılmasına yardımcı olur</li>
        <li><strong>Mimari Estetik:</strong> Modern ve profesyonel görünüm kazandırır</li>
        <li><strong>Erişilebilirlik:</strong> Engelli erişim standartlarına uygun tasarım</li>
        <li><strong>Esneklik:</strong> Farklı salon boyutlarına uyum sağlar</li>
      </ul>
      
      <h3>Uygulama Yöntemleri</h3>
      <p>Zemin yükseltme sistemleri, salonun boyutuna ve ihtiyacına göre farklı yöntemlerle uygulanabilir:</p>
      <ul>
        <li><strong>Betonarme Basamaklar:</strong> Kalıcı ve dayanıklı çözüm</li>
        <li><strong>Çelik Konstrüksiyon:</strong> Hızlı montaj, esnek yapı</li>
        <li><strong>Modüler Sistemler:</strong> Kolay değiştirilebilir, yeniden yapılandırılabilir</li>
        <li><strong>Hibrit Sistemler:</strong> Farklı malzemelerin kombinasyonu</li>
      </ul>
      
      <h3>Teknik Özellikler</h3>
      <p>Nish Global zemin yükseltme sistemleri:</p>
      <ul>
        <li>Yüksek yük taşıma kapasitesi</li>
        <li>Yangına dayanıklı malzemeler</li>
        <li>Akustik yalıtım özellikleri</li>
        <li>Kolay bakım ve temizlik</li>
        <li>Uzun ömürlü yapı</li>
      </ul>
    `
  },
  'salon-zemin-dosemeleri': {
    title: 'Salon Zemin Döşemeleri',
    description: 'Dayanıklı ve estetik zemin döşeme çözümleri',
    type: 'Zemin Döşeme Tipi',
    image: '/yapiakustikcozumler/salonzemindosemeleri.jpg.avif',
    images: [
      '/yapiakustikcozumler/salonzemindosemeleri.jpg.avif'
    ],
    features: [
      'Yoğun kullanıma dayanıklı',
      'Kolay temizlik ve bakım',
      'Estetik görünüm',
      'Akustik özellikler',
      'Uzun ömürlü'
    ],
    content: `
      <p>Konferans salonlarında zemin döşemeleri, hem dayanıklılık hem de estetik açıdan önemlidir. Yoğun kullanıma uygun, şık ve uzun ömürlü döşeme çözümleriyle projelerimizin zeminini güvenle oluşturuyoruz.</p>
      
      <h3>Döşeme Malzemeleri</h3>
      <p>Salon zeminlerinde kullanılan başlıca malzemeler:</p>
      <ul>
        <li><strong>Halı Döşemeler:</strong> Yüksek kaliteli, akustik özellikli halılar</li>
        <li><strong>Vinil Döşemeler:</strong> Dayanıklı, kolay temizlenebilir, modern görünüm</li>
        <li><strong>Ahşap Döşemeler:</strong> Doğal ve şık, özel bakım gerektirir</li>
        <li><strong>Laminat Döşemeler:</strong> Ekonomik, dayanıklı, çeşitli desen seçenekleri</li>
        <li><strong>Seramik/Karo:</strong> Çok dayanıklı, hijyenik, kolay bakım</li>
      </ul>
      
      <h3>Seçim Kriterleri</h3>
      <p>Zemin döşemesi seçiminde dikkate alınması gereken faktörler:</p>
      <ul>
        <li>Kullanım yoğunluğu ve trafik</li>
        <li>Akustik gereksinimler</li>
        <li>Bakım kolaylığı</li>
        <li>Estetik tercihler</li>
        <li>Bütçe ve maliyet</li>
        <li>Çevre dostu özellikler</li>
      </ul>
      
      <h3>Nish Global Hizmetleri</h3>
      <p>Profesyonel ekibimiz, zemin döşeme projelerinde:</p>
      <ul>
        <li>İhtiyaç analizi ve öneriler</li>
        <li>Malzeme seçimi danışmanlığı</li>
        <li>Profesyonel montaj</li>
        <li>Bakım ve onarım hizmetleri</li>
        <li>Garanti ve sertifikasyon</li>
      </ul>
    `
  },
  'salon-ses-sistemleri': {
    title: 'Salon Ses Sistemleri',
    description: 'Profesyonel ses sistemleri kurulumu ve entegrasyonu',
    type: 'Ses Sistemi Tipi',
    image: '/yapiakustikcozumler/sessistemleri.jpg.avif',
    images: [
      '/yapiakustikcozumler/sessistemleri.jpg.avif'
    ],
    features: [
      'Yüksek kalite ses',
      'Akustik uyumlu tasarım',
      'Kolay kullanım',
      'Genişletilebilir sistem',
      'Profesyonel kurulum'
    ],
    content: `
      <p>Profesyonel ses sistemleri, konferans salonlarının vazgeçilmez unsurlarıdır. Her projeye özel tasarlanan ses sistemleri, salonun akustik özelliklerine uygun şekilde planlanır ve kurulur.</p>
      
      <h3>Ses Sistemi Bileşenleri</h3>
      <p>Modern konferans salonu ses sistemleri şu bileşenlerden oluşur:</p>
      <ul>
        <li><strong>Hoparlör Sistemleri:</strong> Yüksek kaliteli, salon boyutuna uygun hoparlörler</li>
        <li><strong>Mikrofon Sistemleri:</strong> Kablolu ve kablosuz mikrofon çözümleri</li>
        <li><strong>Mikser ve Amplifikatörler:</strong> Profesyonel ses işleme ekipmanları</li>
        <li><strong>Ses İşleme Sistemleri:</strong> EQ, kompresör, reverb gibi efekt üniteleri</li>
        <li><strong>Kontrol Sistemleri:</strong> Kullanıcı dostu kontrol arayüzleri</li>
      </ul>
      
      <h3>Sistem Tasarımı</h3>
      <p>Nish Global, her salon için özel ses sistemi tasarımı yapar:</p>
      <ul>
        <li>Salon akustiği analizi</li>
        <li>Hoparlör yerleşim optimizasyonu</li>
        <li>Ses yayılımı simülasyonu</li>
        <li>Kablolama ve altyapı planlaması</li>
        <li>Test ve kalibrasyon</li>
      </ul>
      
      <h3>Teknik Özellikler</h3>
      <p>Kurduğumuz ses sistemleri:</p>
      <ul>
        <li>Yüksek ses kalitesi ve netlik</li>
        <li>Geniş frekans aralığı</li>
        <li>Düşük gürültü seviyesi</li>
        <li>Uzun mesafe ses iletimi</li>
        <li>Kolay bakım ve güncelleme</li>
      </ul>
    `
  },
  'salon-aydinlatma-sistemleri': {
    title: 'Salon Aydınlatma Sistemleri',
    description: 'Modern ve enerji verimli aydınlatma çözümleri',
    type: 'Sistem Tipi',
    image: '/yapiakustikcozumler/isiksistemleri.jpg.avif',
    images: [
      '/yapiakustikcozumler/isiksistemleri.jpg.avif'
    ],
    features: [
      'LED teknolojisi',
      'Enerji verimliliği',
      'Dimmer kontrolü',
      'Uzun ömür',
      'Modern tasarım'
    ],
    content: `
      <p>Modern aydınlatma sistemleri, konferans salonlarında hem işlevsellik hem de estetik açıdan önemlidir. Enerji verimli ve uzun ömürlü aydınlatma çözümleriyle salonlarınızı aydınlatıyoruz.</p>
      
      <h3>Aydınlatma Çözümleri</h3>
      <p>Konferans salonlarında kullanılan aydınlatma türleri:</p>
      <ul>
        <li><strong>Genel Aydınlatma:</strong> Salonun genel aydınlatma ihtiyacını karşılar</li>
        <li><strong>Odak Aydınlatma:</strong> Sahne ve konuşmacı alanını vurgular</li>
        <li><strong>Ambient Aydınlatma:</strong> Atmosfer ve ambiyans oluşturur</li>
        <li><strong>Acil Durum Aydınlatması:</strong> Güvenlik standartlarına uygun</li>
        <li><strong>Dekoratif Aydınlatma:</strong> Estetik katkı sağlar</li>
      </ul>
      
      <h3>LED Teknolojisi</h3>
      <p>Modern aydınlatma sistemlerinde LED teknolojisi tercih edilir çünkü:</p>
      <ul>
        <li>Yüksek enerji verimliliği</li>
        <li>Uzun kullanım ömrü</li>
        <li>Düşük ısı üretimi</li>
        <li>Renk sıcaklığı kontrolü</li>
        <li>Çevre dostu yapı</li>
      </ul>
      
      <h3>Kontrol Sistemleri</h3>
      <p>Aydınlatma kontrol sistemleri ile:</p>
      <ul>
        <li>Merkezi kontrol ve yönetim</li>
        <li>Zamanlayıcı ve senaryo ayarları</li>
        <li>Enerji tüketimi takibi</li>
        <li>Uzaktan kontrol imkanı</li>
        <li>Otomatik kapatma/açma</li>
      </ul>
    `
  },
  'salon-goruntu-sistemleri': {
    title: 'Salon Görüntü Sistemleri',
    description: 'Yüksek çözünürlüklü projeksiyon ve ekran sistemleri',
    type: 'Sistem Tipi',
    image: '/yapiakustikcozumler/goruntusistemleri.avif',
    images: [
      '/yapiakustikcozumler/goruntusistemleri.avif'
    ],
    features: [
      'Yüksek çözünürlük',
      'Geniş ekran boyutları',
      'HDMI ve kablosuz bağlantı',
      'Kolay kurulum',
      'Uzun ömürlü projektörler'
    ],
    content: `
      <p>Profesyonel görüntü sistemleri, konferans salonlarında sunumların etkili bir şekilde aktarılmasını sağlar. Yüksek çözünürlüklü projeksiyon ve ekran sistemleriyle salonlarınızı donatıyoruz.</p>
      
      <h3>Görüntü Sistemi Bileşenleri</h3>
      <p>Modern görüntü sistemleri şunları içerir:</p>
      <ul>
        <li><strong>Projektörler:</strong> Yüksek lümen değerli, uzun ömürlü projektörler</li>
        <li><strong>Ekranlar:</strong> Motorlu veya manuel, farklı boyutlarda ekranlar</li>
        <li><strong>Video İşleme:</strong> Sinyal dağıtıcılar ve switcher'lar</li>
        <li><strong>Kablolama:</strong> HDMI, VGA, DisplayPort bağlantıları</li>
        <li><strong>Kontrol Sistemleri:</strong> Merkezi kontrol ve yönetim</li>
      </ul>
      
      <h3>Projeksiyon Teknolojileri</h3>
      <p>Kullanılan projeksiyon teknolojileri:</p>
      <ul>
        <li><strong>DLP Teknolojisi:</strong> Yüksek kontrast, net görüntü</li>
        <li><strong>LCD Teknolojisi:</strong> Canlı renkler, geniş görüş açısı</li>
        <li><strong>Lazer Projektörler:</strong> Uzun ömür, düşük bakım</li>
        <li><strong>LED Projektörler:</strong> Enerji verimli, kompakt</li>
      </ul>
      
      <h3>Kurulum ve Entegrasyon</h3>
      <p>Nish Global görüntü sistemleri kurulumunda:</p>
      <ul>
        <li>Salon boyutuna uygun ekran seçimi</li>
        <li>Optimal projektör yerleşimi</li>
        <li>Kablolama ve altyapı kurulumu</li>
        <li>Ses sistemleri ile entegrasyon</li>
        <li>Test ve kalibrasyon</li>
        <li>Kullanıcı eğitimi</li>
      </ul>
    `
  },
  'kirim-yikim-tadilat': {
    title: 'Kırım - Yıkım - Tadilat',
    description: 'Güvenli ve profesyonel kırım, yıkım ve tadilat hizmetleri',
    type: '',
    image: '/yapiakustikcozumler/yikimtadilat.jpg.avif',
    images: [
      '/yapiakustikcozumler/yikimtadilat.jpg.avif'
    ],
    features: [
      'Güvenli yıkım',
      'Hızlı temizlik',
      'Profesyonel ekip',
      'Çevre dostu',
      'İzin ve belgeler'
    ],
    content: `
      <p>Kırım, yıkım ve tadilat hizmetlerimiz ile mevcut salonlarınızı yeniden yapılandırıyoruz. Profesyonel ekibimiz, güvenli ve verimli bir şekilde çalışarak salonlarınızı modern standartlara uygun hale getiriyor.</p>
      
      <h3>Hizmet Kapsamımız</h3>
      <p>Nish Global olarak sunduğumuz hizmetler:</p>
      <ul>
        <li><strong>Kırım İşleri:</strong> Duvar, tavan, zemin kırım işlemleri</li>
        <li><strong>Yıkım İşleri:</strong> Güvenli ve kontrollü yıkım</li>
        <li><strong>Tadilat İşleri:</strong> Yenileme ve modernizasyon</li>
        <li><strong>Hafriyat:</strong> Zemin kazı ve temizlik</li>
        <li><strong>Atık Yönetimi:</strong> Çevre dostu atık toplama ve geri dönüşüm</li>
      </ul>
      
      <h3>Güvenlik ve Standartlar</h3>
      <p>Tüm işlemlerimizde:</p>
      <ul>
        <li>İş güvenliği standartlarına uyum</li>
        <li>Çevre koruma yönetmeliklerine uygunluk</li>
        <li>Gerekli izin ve belgelerin temini</li>
        <li>Sigorta ve garanti kapsamı</li>
        <li>Düzenli güvenlik kontrolleri</li>
      </ul>
      
      <h3>Proje Yönetimi</h3>
      <p>Her projede:</p>
      <ul>
        <li>Detaylı proje planlaması</li>
        <li>Zaman çizelgesi takibi</li>
        <li>Kalite kontrol süreçleri</li>
        <li>Düzenli raporlama</li>
        <li>Müşteri iletişimi</li>
      </ul>
    `
  }
};

const StructureAcoustic: React.FC = () => {
  const { t } = useTranslation();
  const [selectedService, setSelectedService] = useState<string | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const getServiceSlug = (title: string): string => {
    const slugMap: { [key: string]: string } = {
      'Akustik Duvar Yapımı': 'akustik-duvar-yapimi',
      'Akustik Tavan Yapımı': 'akustik-tavan-yapimi',
      'Zemin Yükseltme': 'zemin-yukseltme',
      'Salon Zemin Döşemeleri': 'salon-zemin-dosemeleri',
      'Salon Ses Sistemleri': 'salon-ses-sistemleri',
      'Salon Aydınlatma Sistemleri': 'salon-aydinlatma-sistemleri',
      'Salon Görüntü Sistemleri': 'salon-goruntu-sistemleri',
      'Kırım - Yıkım - Tadilat': 'kirim-yikim-tadilat'
    };
    return slugMap[title] || title.toLowerCase().replace(/\s+/g, '-');
  };

  const handleServiceClick = (title: string) => {
    const slug = getServiceSlug(title);
    setSelectedService(slug);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedService(null);
  };

  const services = [
    {
      title: t('structureAcoustic.services.akustikDuvar.title'),
      description: t('structureAcoustic.services.akustikDuvar.description'),
      type: 'Yalıtım Tipi',
      image: '/yapiakustikcozumler/akustikduvar.jpg.avif'
    },
    {
      title: t('structureAcoustic.services.akustikTavan.title'),
      description: t('structureAcoustic.services.akustikTavan.description'),
      type: 'Yalıtım Tipi',
      image: '/yapiakustikcozumler/akustiktavan.jpg.avif'
    },
    {
      title: t('structureAcoustic.services.zeminYukseltme.title'),
      description: t('structureAcoustic.services.zeminYukseltme.description'),
      type: 'Basamak Tipi',
      image: '/yapiakustikcozumler/zeminyukseltme.jpg.avif'
    },
    {
      title: t('structureAcoustic.services.salonZemin.title'),
      description: t('structureAcoustic.services.salonZemin.description'),
      type: 'Zemin Döşeme Tipi',
      image: '/yapiakustikcozumler/salonzemindosemeleri.jpg.avif'
    },
    {
      title: t('structureAcoustic.services.salonSes.title'),
      description: t('structureAcoustic.services.salonSes.description'),
      type: 'Ses Sistemi Tipi',
      image: '/yapiakustikcozumler/sessistemleri.jpg.avif'
    },
    {
      title: t('structureAcoustic.services.salonAydinlatma.title'),
      description: t('structureAcoustic.services.salonAydinlatma.description'),
      type: 'Sistem Tipi',
      image: '/yapiakustikcozumler/isiksistemleri.jpg.avif'
    },
    {
      title: t('structureAcoustic.services.salonGoruntu.title'),
      description: t('structureAcoustic.services.salonGoruntu.description'),
      type: 'Sistem Tipi',
      image: '/yapiakustikcozumler/goruntusistemleri.avif'
    },
    {
      title: t('structureAcoustic.services.kirimYikim.title'),
      description: t('structureAcoustic.services.kirimYikim.description'),
      type: '',
      image: '/yapiakustikcozumler/yikimtadilat.jpg.avif'
    }
  ];

  return (
    <div className="structure-acoustic-page">
      <section className="articles-hero">
        <div className="articles-hero-content">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="articles-hero-text"
          >
            <h1>{t('structureAcoustic.pageTitle')}</h1>
            <p className="articles-hero-subtitle">
              {t('structureAcoustic.subtitle')}
            </p>
          </motion.div>
        </div>
      </section>

      <div className="page-container">
        <div className="services-section">
          <h3 className="section-title">{t('structureAcoustic.servicesTitle')}</h3>
          <div className="products-grid">
            {services.map((service, index) => (
              <div 
                key={index} 
                className="product-card"
                onClick={() => handleServiceClick(service.title)}
                style={{ cursor: 'pointer' }}
              >
                <div className="product-image">
                  <img src={service.image} alt={service.title} />
                  <div className="product-overlay">
                    <span className="view-details">{t('common.viewDetails') || 'Detayları Gör'}</span>
                  </div>
                </div>
                <div className="product-info">
                  <h3>{service.title}</h3>
                  {service.description && (
                    <p className="product-description">{service.description}</p>
                  )}
                  <button 
                    className="quote-button"
                    onClick={(e) => {
                      e.stopPropagation();
                      window.open(`https://wa.me/905408072727?text=Merhaba,%20${encodeURIComponent(service.title)}%20için%20teklif%20almak%20istiyorum.`, '_blank');
                    }}
                  >
                    {t('common.getQuote')}
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="materials-section">
          <div className="materials-header">
            <h3 className="section-title">{t('structureAcoustic.qualityTitle')}</h3>
            <p className="materials-intro">
              {t('structureAcoustic.qualityDesc')}
            </p>
          </div>
          <div className="materials-grid">
            <div className="material-card">
              <div className="material-icon">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M12 2L2 7l10 5 10-5-10-5z"></path>
                  <path d="M2 17l10 5 10-5"></path>
                  <path d="M2 12l10 5 10-5"></path>
                </svg>
              </div>
              <h4>{t('structureAcoustic.materialQuality.title')}</h4>
              <p>
                {t('structureAcoustic.materialQuality.description')}
              </p>
            </div>

            <div className="material-card">
              <div className="material-icon">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                  <line x1="9" y1="3" x2="9" y2="21"></line>
                  <line x1="15" y1="3" x2="15" y2="21"></line>
                  <line x1="3" y1="9" x2="21" y2="9"></line>
                  <line x1="3" y1="15" x2="21" y2="15"></line>
                </svg>
              </div>
              <h4>{t('structureAcoustic.systemPartnership.title')}</h4>
              <p>
                {t('structureAcoustic.systemPartnership.description')}
              </p>
            </div>

            <div className="material-card">
              <div className="material-icon">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
                  <line x1="8" y1="21" x2="16" y2="21"></line>
                  <line x1="12" y1="17" x2="12" y2="21"></line>
                </svg>
              </div>
              <h4>{t('structureAcoustic.floorAesthetic.title')}</h4>
              <p>
                {t('structureAcoustic.floorAesthetic.description')}
              </p>
            </div>
          </div>
        </div>
      </div>

      <ServiceModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        service={selectedService ? serviceData[selectedService] : null}
      />
    </div>
  );
};

export default StructureAcoustic;
